import { Component } from '@angular/core';

@Component({
  selector: 'app-franchise',
  template: `<router-outlet></router-outlet>`,
})
export class FranchiseComponent {
  constructor() { }
}
